<template>
  <router-link
    :to="invoiceRoute"
    class="invoice p-2 flex text-sm justify-between items-center cursor-pointer"
    :class="css"
    @click.native.prevent="gotoInvoice"
    event
  >
    <div class="w-full flex justify-between">
      <div class="flex items-center w-1/2">
        <div class="flex flex-col">
          <span
            class="w-24 text-right whitespace-no-wrap"
            v-html="data.credits"
          ></span>
          <span
            class="w-24 pr-1 whitespace-no-wrap text-right text-gray-800"
            v-html="data.amount"
            v-if="!data.isGift && !data.isTransfer"
          ></span>
        </div>
        <span class="pl-3">
          <span v-text="data.product"></span>
          <span v-text="' #' + data.number" v-if="hasInvoice"></span>
        </span>
      </div>

      <div class="flex items-center justify-end capitalize">
        <div class="flex items-center mr-3" v-html="data.date"></div>
        <div class="w-24 text-center" v-if="data.isTransfer">
          <font-awesome-icon icon="exchange-alt" fixed-width />
        </div>
        <div class="w-24 text-center" v-else-if="data.isGift">
          <font-awesome-icon :icon="['fas', 'gift']" fixed-width />
        </div>
        <div v-else>
          <div
            :class="
              'whitespace-no-wrap w-24 text-xs p-1 status ' + data.status.id
            "
            v-text="data.status.label"
          ></div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      id: this.data.id,
    };
  },
  methods: {
    gotoInvoice() {
      if (this.data.id == this.$route.params.id) {
        this.$router.push({
          name: "invoice.welcome",
          params: {
            locale: this.$route.params.locale,
          },
        });
        return;
      }
      this.$router.push(this.invoiceRoute);
    },
  },
  computed: {
    isSelected() {
      return this.id == this.$route.params.id;
    },

    invoiceRoute() {
      return {
        name: "invoice.index",
        params: { id: this.data.id, locale: this.$route.params.locale },
      };
    },

    statusLabel() {
      if (this.$store.state.safe.i18n === undefined) return "";

      return this.$store.state.safe.i18n.invoice.status.label[this.data.status];
    },

    css() {
      if (this.isSelected) {
        return "bg-gray-200";
      }

      return "hover:bg-gray-100";
    },

    hasInvoice() {
      return this.data.number > 0;
    },
  },
};
</script>
